export function useFlexiblePrice(ticketType: TicketType): boolean {
  return Boolean(ticketType.currency_amount_max && ticketType.currency_amount_min)
}
